import React, { Component } from 'react';

class GoogleAd extends Component {
  componentDidMount() {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }
  render(){

    return(
      <div style={this.props.wrapperDivStyle} > 
      <ins className="adsbygoogle"  
        style={{'display': 'block'}}
        data-ad-client={this.props.client}
        data-ad-slot={this.props.slot}
        data-ad-layout-key={this.props.layoutKey}
        data-ad-format={this.props.format}>
      </ins>
    </div>
    );
  }
}
export default GoogleAd;


// WEBPACK FOOTER //
// ./src/components/pieces/GoogleAd.js